var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{staticClass:"mx-auto",attrs:{"col":"12","sm":"12"}},[_c('Form',{ref:"campaignForm",attrs:{"submit":_vm.submit,"campaign":_vm.$deepClone(_vm.campaign)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }